export const questions = [
  {
    id: 1,
    question: "Qual imagem corresponde melhor ao seu tipo de cabelo?",
    type: "image-choice" as const,
    options: [
      {
        id: "grau-1-2",
        label: "",
        description: "",
        image: "https://static.readdy.ai/image/785f619f14da191e5d57c91443a7c86c/a5587e104a2a88be12438087f37e5116.png"
      },
      {
        id: "grau-3-4",
        label: "",
        description: "",
        image: "https://static.readdy.ai/image/785f619f14da191e5d57c91443a7c86c/3791a739f4e36bed13033ac55e0a2562.png"
      },
      {
        id: "grau-5",
        label: "",
        description: "",
        image: "https://static.readdy.ai/image/785f619f14da191e5d57c91443a7c86c/8f8eca9eeed50ad8fcd2c8c32fb67178.png"
      }
    ]
  },
  {
    id: 2,
    question: "Qual é a sua idade?",
    type: "single" as const,
    options: [
      { id: "18-25", label: "18-25 anos" },
      { id: "26-35", label: "26-35 anos" },
      { id: "36-45", label: "36-45 anos" },
      { id: "46+", label: "46+ anos" }
    ]
  },
  {
    id: 3,
    question: "Há quanto tempo você notou a queda de cabelo?",
    type: "single" as const,
    options: [
      { id: "recent", label: "Menos de 6 meses" },
      { id: "moderate", label: "6 meses a 2 anos" },
      { id: "long", label: "Mais de 2 anos" }
    ]
  },
  {
    id: 4,
    question: "Você já tentou algum tratamento para calvície?",
    type: "single" as const,
    options: [
      { id: "no", label: "Não, nunca tentei" },
      { id: "yes-natural", label: "Sim, produtos naturais" },
      { id: "yes-medical", label: "Sim, tratamentos médicos" },
      { id: "yes-both", label: "Sim, ambos" }
    ]
  },
  {
    id: 5,
    question: "Qual é o seu principal objetivo?",
    type: "single" as const,
    options: [
      { id: "stop", label: "Parar a queda de cabelo" },
      { id: "fill", label: "Preencher as falhas" },
      { id: "both", label: "Ambos" }
    ]
  },
  {
    id: 6,
    question: "Como está a condição do seu couro cabeludo?",
    type: "single" as const,
    options: [
      { id: "oleoso", label: "Seu cabelo é oleoso" },
      { id: "caspa", label: "Você tem caspa" },
      { id: "ambos", label: "Ambos" }
    ]
  }
];
